import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider, OrderProvider, PathNameProvider } from "./contexts";
import store from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import "./fonts/Comfortaa/Comfortaa-Bold.woff";
import "./fonts/Lato/Lato-Regular.woff";
import "./fonts/Lato/Lato-Medium.woff";
import "./fonts/Lato/Lato-Semibold.woff";
import "./fonts/Lato/Lato-Bold.woff";
import "./fonts/Lato/Lato-Heavy.woff";
import "./fonts/Lato/Lato-Black.woff";
import "./fonts/Nexa/Nexa-Bold.otf";
import "./fonts/Roboto/Roboto-Bold.woff";
import "./index.css";

let persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <Router>
          <PathNameProvider>
            <AppProvider>
              <OrderProvider>
                <App />
              </OrderProvider>
            </AppProvider>
          </PathNameProvider>
        </Router>
      </React.StrictMode>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
